import { createI18n } from 'vue-i18n'

function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

// Idioma por defecto (compatible con vue.config.js)
const defaultLocale = 'en'

// Obtener idioma del navegador o localStorage
const getInitialLocale = () => {
  // 1. Si hay idioma guardado en localStorage (usuario logueado), usar ese
  const savedLocale = localStorage.getItem('i18n-language')
  if (savedLocale) {
    return savedLocale
  }

  // 2. Si no, usar idioma del navegador
  const browserLang = navigator.language.split('-')[0].toLowerCase()

  // 3. Verificar que el idioma del navegador esté soportado, sino usar inglés
  return ['en', 'es', 'fr', 'de', 'it', 'pt'].includes(browserLang) ? browserLang : defaultLocale
}

const i18n = createI18n({
  legacy: false, // Usar Composition API
  locale: getInitialLocale(),
  fallbackLocale: defaultLocale, // Compatible con vue.config.js
  globalInjection: true,
  messages: loadLocaleMessages()
})

export default i18n

// Función para cambiar idioma
export const setI18nLanguage = (locale) => {
  i18n.global.locale.value = locale
  localStorage.setItem('i18n-language', locale) // Cambiado para consistencia
  document.querySelector('html').setAttribute('lang', locale)
}

// Función para obtener idioma actual
export const getCurrentLanguage = () => {
  return i18n.global.locale.value
}
